import { useEffect } from "react";
import { useParams } from "react-router-dom";
//
import { useTranslation } from "react-i18next";

export default function LanguageDetector() {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && lang !== "") {
      let resolvedLang = "en-EN";
      const language = lang.toLocaleLowerCase();
      switch (language) {
        case "it":
          resolvedLang = "it-IT";
          break;
        case "fr":
          resolvedLang = "fr-FR";
          break;
        case "de":
          resolvedLang = "de-DE";
          break;
        case "es":
          resolvedLang = "es-ES";
          break;
      }
      i18n.changeLanguage(resolvedLang);
    }

    window.location.href = "/";
    return;
  }, []);

  return null;
}
